import { ComponentType } from "@angular/cdk/portal";
import { Injectable } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AlertDialogComponent } from "@assoanalytics/app/shared/components/alert-dialog/alert-dialog.component";

// Import diretto per confronto tipo
import { DataMismatchWarningComponent } from "@assoanalytics/app/modules/dashboard/components/data-mismatch-warning/data-mismatch-warning.component";

@Injectable({
  providedIn: "root",
})
export class AlertDialogService {
  constructor(private dialog: MatDialog) {}

  private dialogRef: MatDialogRef<any>;

  // Flag per evitare doppia apertura dialog warning
  private warnDialogShown = false;

  // show default modal
  create(
    data: AlertDialogData,
    callbackConfirm?: Function,
    callbackCancel?: Function,
  ) {
    if (!data.type) {
      data.type = "default";
    }

    this.dialogRef = this.dialog.open(AlertDialogComponent, {
      data: data,
      disableClose: data.disableClose ?? false,
    });

    this.dialogRef.afterClosed().subscribe({
      next: (value) => {
        if (value && callbackConfirm) {
          callbackConfirm();
        }
        if (!value && callbackCancel) {
          callbackCancel();
        }
      },
    });
  }

  // show custom modal
  openModal<T extends ComponentType<any>>(
    component: T,
    data?: any,
    disableClose: boolean = false,
  ): MatDialogRef<any> | null {
    // Solo per DataMismatchWarningComponent: mostra una sola volta
    if ((component as any).name === "_DataMismatchWarningComponent") {
      if (this.warnDialogShown) return null;
      this.warnDialogShown = true;
    }

    const alreadyOpen = this.dialog.openDialogs.some(
      (ref) => ref.componentInstance instanceof component,
    );
    if (alreadyOpen) return null;

    const ref = this.dialog.open(component, {
      data: data,
      width: data?.width ?? "700px",
      disableClose: disableClose,
    });

    return ref;
  }

  close() {
    this.dialogRef.close();
  }

  closeModal() {
    this.dialog.closeAll();
  }
}

export type AlertDialogData = {
  title: string;
  messages: string[];
  confirm?: string;
  cancel?: string;
  type?: "default" | "warning";
  disableClose?: boolean;
};
